import { toast } from 'sonner';

/**
 * Handle API error responses and display appropriate toast messages
 * @param error - The error object from RTK Query
 * @param fallbackMessage - Optional fallback message if no specific error is found
 */
export function handleApiError(error: any, fallbackMessage?: string): void {
  // Handle detail error message
  if (error?.data?.detail) {
    toast.error(error.data.detail);
    return;
  }
  
  // Handle message error
  if (error?.data?.message) {
    toast.error(error.data.message);
    return;
  }
  
  // Handle field-specific errors (validation errors)
  if (error?.data && typeof error.data === 'object') {
    const entries = Object.entries(error.data);
    let hasFieldErrors = false;
    
    entries.forEach(([field, messages]) => {
      if (Array.isArray(messages)) {
        hasFieldErrors = true;
        messages.forEach((message: string) =>
          toast.error(`${field}: ${message}`)
        );
      } else if (typeof messages === 'string') {
        hasFieldErrors = true;
        toast.error(`${field}: ${messages}`);
      }
    });
    
    if (hasFieldErrors) return;
  }
  
  // Fallback message
  if (fallbackMessage) {
    toast.error(fallbackMessage);
  }
}

